function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var SubscriptionsApiService = /*#__PURE__*/function () {
  function SubscriptionsApiService() {
    _classCallCheck(this, SubscriptionsApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(SubscriptionsApiService, [{
    key: "GetSubscriptions",
    value: function GetSubscriptions() {
      var searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var congregationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var orderByName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var orderDescending = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var url = "".concat(this._appRoot, "/Api/SubscriptionsApi/GetSubscriptions?searchTerm=").concat(searchTerm, "&congregationFilter=").concat(congregationId, "&orderByName=").concat(orderByName, "&orderDescending=").concat(orderDescending);
      return Ajax.Get(url, true);
    }
  }, {
    key: "UpdateSubscriptions",
    value: function UpdateSubscriptions(formData) {
      var url = "".concat(this._appRoot, "/Api/SubscriptionsApi/UpdateSubscriptions");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "Unsubscribe",
    value: function Unsubscribe(contactGuid, publicationId) {
      var url = "".concat(this._appRoot, "/Api/SubscriptionsApi/Unsubscribe?contactGuid=").concat(contactGuid, "&publicationId=").concat(publicationId);
      return Ajax.Get(url);
    }
  }, {
    key: "UndoUnsubscribe",
    value: function UndoUnsubscribe(contactGuid, publicationId) {
      var url = "".concat(this._appRoot, "/Api/SubscriptionsApi/UndoUnsubscribe?contactGuid=").concat(contactGuid, "&publicationId=").concat(publicationId);
      return Ajax.Get(url);
    }
  }, {
    key: "GetBulkEmailOptOut",
    value: function GetBulkEmailOptOut() {
      var url = "".concat(this._appRoot, "/Api/SubscriptionsApi/GetBulkEmailOptOut");
      return Ajax.Get(url);
    }
  }, {
    key: "BulkEmailOptOut",
    value: function BulkEmailOptOut(optOut) {
      var url = "".concat(this._appRoot, "/Api/SubscriptionsApi/BulkEmailOptOut?optOut=").concat(optOut);
      return Ajax.Get(url);
    }
  }]);

  return SubscriptionsApiService;
}();